/**
 * How long an offer, a counter-offer and an accepted offer's payment each
 * wait, in hours (client decision 2026-10-08). The server stamps each offer's
 * own deadline from its copy (server/api-util/deadline-rules.js
 * RULES.offerHours); offerWindow.parity.test.js keeps the two equal.
 */
export const OFFER_HOURS = 24;
